export enum RealtimeRole {
  Provider = 'Provider',
  Patient = 'Patient',
  System = 'System',
  Spectator = 'Spectator',
  Auditor = 'Auditor',
}
